export default __webpack_public_path__ + "static/media/welcome-line.aa0a077d.svg";